import React, { Component } from "react";
import Input from "../common/Input";
import Textarea from "../common/Textarea";
import Service from "../common/Service";
import add from "../assets/add.svg";
import boxes from "../assets/boxes.svg";
import { NavLink, Redirect } from "react-router-dom";
import BackArrow from "../common/BackArrow";
import API from "../common/Api";
import { connect } from "react-redux";
import { Shimmer } from "react-shimmer";
import Select from "../common/Select";
import { durations } from "../home/onboarding/ServiceSettings";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import CheckBox from "../common/Check-box";
import close from "../assets/close.svg";
import MediaDnDList from "./MediaDnDList";
import { reCreateNewDragula } from "../utils/dragula";
import Toggle from "../common/Toggle-button";

const mapStateToProps = (state) => ({
  headers: state.headers(),
});

export default connect(mapStateToProps)(
  class ServiceSettings extends Component {
    state = {
      addCat: false,
      add_new_service: false,
      editFormIsOpen: false,
      editFormDefaults: {},
      selectedCategories: [],
      add_another_service: false,
      categories: [],
      allMedia: [],
      selectedServices: [],
      services: [],
      isLoading: true,
      submitingService: false,
      mediaFiles: [],
      // Group session fields
      isVirtual: false,
      isGroupSession: false,
      maxParticipants: 2,
      // Edit form group session fields
      editIsVirtual: false,
      editIsGroupSession: false,
      editMaxParticipants: 2,
    };

    editServiceForm = React.createRef();
    DurationInputRef = React.createRef();

    serviceDragRef = React.createRef();


    handleFileChange = (e) => {
      const files = Array.from(e.target.files);
      const { mediaFiles, allMedia } = this.state;

      if (allMedia.length + files.length > 5) {
        alert("You can only select up to 5 images or videos in total.");
        e.target = "";
        return;
      }
      const tooBig = files.find((file) => file.size > 25 * 1024 * 1024);
      if (tooBig) {
        alert(`${tooBig.name} is too large. Max size of 25mb`);
        e.target = "";
        return;
      }

      // Create new mediaFiles with preview URLs
      const newMediaFiles = files.map((file) => ({
        file,
        preview: URL.createObjectURL(file),
      }));

      // Build the new allMedia entries for these new files
      const newAllMediaItems = newMediaFiles.map((media, i) => ({
        id: `new-${mediaFiles.length + i}`, // ensure unique
        type: media.file?.type?.startsWith("image") ? "image" : "video",
        url: media.preview,
        existing: false,
        original_file: media,
      }));

      // Append to existing allMedia
      const updatedAllMedia = [...allMedia, ...newAllMediaItems];

      this.setState({
        mediaFiles: [...mediaFiles, ...newMediaFiles],
        allMedia: updatedAllMedia,
      });
      setTimeout(() => {

      }, 100);
    };

    getFileFromMediaId(mediaFiles, id) {

      const index = parseInt(id.replace("new-", ""), 10);
      return mediaFiles[index]?.file || null;
    }

    closeAddServiceForm = () => {
      this.setState({ addCat: false });
    };

    handleRemove = (id) => {
      this.setState((prev) => {
        // Filter allMedia to remove the item
        const updatedAllMedia = prev.allMedia.filter((item) => item.id !== id);

        // If it's a *new* media item, we also need to remove its file from mediaFiles
        let updatedMediaFiles = prev.mediaFiles;

        // Check if the removed item was new (not existing)
        const removedItem = prev.allMedia.find((item) => item.id === id);
        if (
          removedItem &&
          !removedItem.existing &&
          removedItem.mediaIndex !== undefined
        ) {
          // Revoke preview URL if present
          if (prev.mediaFiles[removedItem.mediaIndex]?.preview) {
            URL.revokeObjectURL(
              prev.mediaFiles[removedItem.mediaIndex].preview
            );
          }

          // Actually remove it from mediaFiles using its index
          updatedMediaFiles = prev.mediaFiles.filter(
            (_, idx) => idx !== removedItem.mediaIndex
          );

          // 🟣 VERY IMPORTANT
          // Because indices shifted, we need to re-map allMedia to correct the mediaIndex fields
          const remappedAllMedia = updatedAllMedia.map((item) => {
            if (!item.existing && item.mediaIndex > removedItem.mediaIndex) {
              // Shift indices down by 1 for items after the removed one
              return { ...item, mediaIndex: item.mediaIndex - 1 };
            }
            return item;
          });

          return {
            allMedia: remappedAllMedia,
            mediaFiles: updatedMediaFiles,
          };
        }

        // If it was an existing item, mediaFiles doesn't change
        return {
          allMedia: updatedAllMedia,
        };
      });
    };

    handleReorder = (newList) => {
      this.setState({ allMedia: newList });
    };

    getServices = () => {
      API.get("business/services", { headers: this.props.headers }).then(
        ({ data }) => {
          this.setState({
            services: data.data.services,
            isLoading: false,
          });
          this.initDragula();
        }
      );
    };
    service_form = () => {
      if (this.state.add_new_service) {
        this.props.history.push({
          pathname: "/services/settings",
        });
      }
      if (this.state.add_new_service) {
        this.setState({ add_another_service: true });
      }
      this.setState({
        add_new_service: !this.state.add_new_service,
        selectedCategories: [],
      });
    };
    all_services = (ev) => {
      ev.preventDefault();
      this.setState({
        submitingService: true,
      });
      const loaded = () =>
        this.setState({
          submitingService: false,
        });
      const form = ev.currentTarget;
      let services = this.state.services;
      let newService = {
        name: form.name.value,
        duration: form.duration.value,
        price: form.price.value,
        description: form.description.value,
        is_active: true,
        is_virtual: this.state.isVirtual,
        is_group_session: this.state.isGroupSession,
        max_capacity: this.state.isGroupSession ? this.state.maxParticipants : null,
        selected_categories: this.state.selectedCategories,
        order: this.state.services.length + 1,
      };

      const formData = new FormData();
      Object.entries(newService).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((item, idx) => {
            formData.append(`services[0][${key}][${idx}]`, item);
          });
        } else if (value !== null) {
          formData.append(`services[0][${key}]`, value);
        }
      });
      formData.append("services[0][is_active]", newService.is_active ? 1 : 0);
      formData.append("services[0][is_virtual]", newService.is_virtual ? 1 : 0);
      formData.append("services[0][is_group_session]", newService.is_group_session ? 1 : 0);
      if (newService.is_group_session && newService.max_capacity) {
        formData.append("services[0][max_capacity]", newService.max_capacity);
      }

      // Add media files (if any)
      this.state.allMedia.forEach((item, index) => {
        formData.append(`media[${index}]`, item.original_file.file);
      });
      API.post("business/services", formData, {
        headers: {
          ...this.props.headers,
          "Content-Type": "multipart/form-data",
        },
      }).then(({ data }) => {
        //
        loaded();
        if (data.success) {
          window.$.notify(
            `Service "${newService.name}"  added`,
            "success-alert"
          );
          form.reset();
          this.setState({
            mediaFiles: [],
            allMedia: [],
            isVirtual: false,
            isGroupSession: false,
            maxParticipants: 2,
          });
          services.push(data.data[0]);

          setTimeout(() => {
            if (!this.state.add_another_service) {
              this.service_form();
            }
          }, 200);
        }
      }, error => {
        this.setState({
          submitingService: false,
        });
        window.$.notify(
          error.response.data.errors[0]?.message ?? error.message ?? "Something went wrong, please try again!",
          "error-alert"
        );
      });
    };

    handleCheckboxChange = (event) => {
      //  
      const id = parseInt(event.target.value); // assuming service.id is a number
      const { selectedServices } = this.state;

      const updatedServices = event.target.checked
        ? [...selectedServices, id]
        : selectedServices.filter((serviceId) => serviceId !== id);
      this.setState({ selectedServices: updatedServices });
    };

    handleCheckboxChangeCat = (event) => {
      const id = parseInt(event.target.value); // assuming is a number
      const { selectedCategories } = this.state;
      const updatedCat = event.target.checked
        ? [...selectedCategories, id]
        : selectedCategories.filter((catId) => catId !== id);
      this.setState({ selectedCategories: updatedCat });


    };

    createCategory = (ev) => {
      ev.preventDefault();
      this.setState({
        is_loading: true,
      });
      const form = ev.currentTarget;

      // return;
      let newCate = {
        name: form.name.value,
        services: this.state.selectedServices,
      };
      if (this.state.editForm) {
        API.put(`categories/${this.state.selectedCat.id}`, newCate, {
          headers: this.props.headers,
        })
          .then(({ data }) => {
            if (data.success) {
              window.$.notify(
                `Category "${newCate.name}" updated successfully!`,
                "success-alert"
              );
              this.getCategories();
              form.reset();
              this.closeAddServiceForm();
            }
          })
          .finally(() => {
            this.setState({
              is_loading: false,
            });
          });
      } else {
        API.post("categories", newCate, { headers: this.props.headers })
          .then(({ data }) => {
            if (data.success) {
              window.$.notify(
                `Category "${newCate.name}" created successfully!`,
                "success-alert"
              );
              this.getCategories();
              form.reset();
              this.closeAddServiceForm();
            }
          })
          .finally(() => {
            this.setState({
              is_loading: false,
            });
          });
      }
    };

    editService = (ev) => {
      ev.preventDefault();
      this.setState({ editingService: true });
      const loaded = () =>
        this.setState({
          editingService: false,
        });
      const form = this.editServiceForm.current;
      const formerServiceDetails = this.state.editFormDefaults;
      const editedServiceDetails = {
        name: form.name.value,
        duration: form.duration.value,
        price: Number(form.price.value),
        is_virtual: this.state.editIsVirtual,
        is_active: String(this.state.editFormDefaults.is_active),
        description: form.description.value,
        selected_categories: this.state.selectedCategories,
        existingMedia: this.state.editFormDefaults.media,
        order: formerServiceDetails.order,
        is_group_session: this.state.editIsGroupSession,
        max_capacity: this.state.editIsGroupSession ? this.state.editMaxParticipants : null,
      };

      const formData = new FormData();

      // Append scalar fields
      formData.append("name", editedServiceDetails.name);
      formData.append("description", editedServiceDetails.description ?? "");
      formData.append("duration", editedServiceDetails.duration ?? "");
      formData.append("price", String(editedServiceDetails.price));
      formData.append("is_virtual", editedServiceDetails.is_virtual ? "true" : "false");
      formData.append("is_active", editedServiceDetails.is_active);
      formData.append("order", editedServiceDetails.order);
      formData.append("is_group_session", editedServiceDetails.is_group_session ? "1" : "0");
      if (editedServiceDetails.is_group_session && editedServiceDetails.max_capacity) {
        formData.append("max_capacity", editedServiceDetails.max_capacity);
      }

      // Append categories as array
      if (Array.isArray(this.state.selectedCategories)) {
        this.state.selectedCategories.forEach((catId, idx) => {
          formData.append(`selected_categories[${idx}]`, catId);
        });
      }



      // Append media
      this.state.allMedia.forEach((item, index) => {
        if (item.existing) {
          formData.append(
            `media[${index}]`,
            JSON.stringify({
              url: item.url,
              type: item.type,
            })
          );
        } else if (item.original_file && item.original_file.file) {
          formData.append(`media[${index}]`, item.original_file.file);
        }
      });
      API.post(
        `business/services/${formerServiceDetails.identifier}`,
        formData,
        {
          headers: {
            ...this.props.headers,
            "Content-Type": "multipart/form-data",
          },
        }
      )
        .then(({ data }) => {
          loaded();
          window.$.notify("Updated Service", "success-alert");
          this.setState({ services: [], isLoading: true });
          this.getServices();
        })
        .catch((error) => {
          loaded();
          this.setState({ isLoading: true });
          window.$.notify(
            error.response.data.errors[0]?.message ?? error.message ?? "Something went wrong, please try again!",
            "error-alert"
          );


        });
    };

    getCategories = () => {
      API.get("categories", { headers: this.props.headers }).then(
        ({ data }) => {
          this.setState({
            categories: data.data,
            isLoading: false,
          });
        }
      );
    };

    deleteService = (data) => {
      // ev.preventDefault();

      // this.setState({ editFormIsOpen: true, editFormDefaults: data });

      //  let asker =  confirm('Ate you sure you want to delete this service ?');

      const options = {
        title: "Confirm deletion",
        message:
          "Are you sure you want to permanently delete this service?      ",
        buttons: [
          {
            label: "Yes, Delete",
            className: "btn btn-danger",

            onClick: () => {
              API.delete(`business/services/${data.identifier}`, {
                headers: this.props.headers,
              }).then(({ data }) => {
                window.$.notify(
                  "Service deleted successfully",
                  "success-alert"
                );
                this.setState({ services: [], isLoading: true });
                this.getServices();
              });
            },
          },
          {
            label: "No, Cancel",
            onClick: () => "",
          },
        ],

        overlayClassName: "overlay-custom-class-name",
      };

      confirmAlert(options);
    };
    openEditServiceForm = (data) => {
      if (this.editServiceForm.current) {
        this.editServiceForm.current.reset();
      }

      this.setState({ editFormDefaults: data });
      this.setState({ selectedCategories: data.categories });
      this.setState({
        editFormDefaults: data,
        selectedCategories: data.categories,
        editIsVirtual: data.is_virtual || false,
        editIsGroupSession: data.is_group_session || false,
        editMaxParticipants: data.max_capacity || 2,
        allMedia: (data?.media ?? []).map((item, i) => ({
          id: `existing-${i}`,
          type: item.type,
          url: item.url,
          existing: true,
        })),
        editFormIsOpen: true,
      });
    };

    closeEditServiceForm = () => {
      if (this.state.editFormIsOpen) {
        this.props.history.push({
          pathname: "/services/settings",
        });
      }
      this.setState({
        editFormIsOpen: false,
        selectedCategories: [],
        allMedia: [],
      });
    };
    componentDidMount = () => {
      const { match } = this.props;

      this.getServices();
      this.getCategories();
      setTimeout(() => {

        if (match.params.action === "add_service") {
          this.setState({ add_new_service: true });
        } else if (
          match.params.action !== "" &&
          match.params.action !== undefined
        ) {
          let services = this.state.services.filter(
            (service) => service.id === parseInt(match.params.action)
          );
          if (services.length) {

            this.openEditServiceForm(services[0]);
          }
        }
      }, 2000);
    };


    addOrderKey(services) {
      return services.map((service, index) => ({
        ...service,
        order: index + 1  // starts from 1
      }));
    }

    initDragula = () => {
      reCreateNewDragula({
        services: this.state.services,
        setServices: (newServices) => this.setState({ services: newServices }),
        servicesRef: this.serviceDragRef
      });
    };


    updateServicesOrder = (services) => {
      const payload = services.map((srv, index) => ({
        id: srv.id,
        order: srv.order ?? index + 1
      }));

      API.post(
        "/business/services/update-order/",
        payload,
        { headers: this.props.headers }
      )
        .then(() => {
          console.log("Order updated!");
        })
        .catch((err) => {
          console.error("Order update failed", err);
        });
    };

    componentDidUpdate(prevProps, prevState) {
      if (prevState.services !== this.state.services) {
        this.debounceUpdateOrder();
      }
    }

    debounceUpdateOrder = () => {
      // Clear previous timer
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      // Set new timer
      this.debounceTimer = setTimeout(() => {
        this.updateServicesOrder(this.state.services);
      }, 700);
    };

    render() {
      const sortedServices = [...this.state.services].sort((a, b) => a.order - b.order);

      return (
        <>
          <div
            style={{
              display:
                (window.innerWidth < 600 && !this.state.addCat) ||
                  window.innerWidth > 600
                  ? "block"
                  : "none",
            }}
            className="onboarding-page app-setting"
          >
            {this.state.redirect ? <Redirect to={this.state.redirect} /> : ""}

            <div className="form_step form-page">
              <div className="header flex space-btw center mobile_block">
                {this.state.add_new_service === false &&
                  this.state.editFormIsOpen === false ? (
                  <h1 className="form-title flex center">
                    {/* <BackArrow /> */}
                    Services
                  </h1>
                ) : (
                  <h1 className="form-title mbl flex center">
                    {this.state.add_new_service ? (
                      <>
                        <BackArrow backFunction={this.service_form} />
                        Add a service
                      </>
                    ) : (
                      <>
                        <BackArrow backFunction={this.closeEditServiceForm} />
                        Edit service
                      </>
                    )}
                  </h1>
                )}

                {this.state.add_new_service || this.state.editFormIsOpen ? (
                  ""
                ) : (
                  <div className="flex ">
                    <button className="co-pink add" onClick={this.service_form}>
                      <img src={add} alt="" />
                      Add a service
                    </button>
                    <NavLink
                      style={{
                        marginLeft: "40px",
                        display: "flex",
                        alignItems: "center",
                      }}
                      className="co-pink add"
                      to="/categories/settings"
                    >
                      <img
                        style={{
                          width: "20px",
                          height: "20px",
                          marginRight: "10px",
                        }}
                        src={boxes}
                        alt=""
                      />
                      Manage categories
                    </NavLink>
                  </div>
                )}
              </div>

              {/* all services */}
              <div
                className="card-container"
                style={{
                  display:
                    this.state.add_new_service || this.state.editFormIsOpen
                      ? "none"
                      : "block",
                }}
              >
                <div className="form-container card services app-setting" ref={this.serviceDragRef}>
                  {/* {this.state.services.map((service) => ( */}
                  {sortedServices.map((service, index) => (
                    <Service
                      data={service}
                      editOnclick={() => this.openEditServiceForm(service)}
                      deleteOnclick={() => this.deleteService(service)}
                      notEditable={false}
                      key={service.id}
                    />
                  ))}
                  {this.state.services.length === 0 && !this.state.isLoading ? (
                    <div>
                      <br />
                      <p className="off">"Services have not been added"</p>
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.isLoading ? (
                    <>
                      <Shimmer className="r-shimer-service" height={91} />
                      <Shimmer className="r-shimer-service" height={91} />
                      <Shimmer className="r-shimer-service" height={91} />
                      <Shimmer className="r-shimer-service" height={91} />
                      <Shimmer className="r-shimer-service" height={91} />
                      <Shimmer className="r-shimer-service" height={91} />
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {/* end of all services */}

              {/* add service modal */}
              <div
                className="onboarding-page"
                style={{
                  display: this.state.add_new_service ? "flex" : "none",
                }}
              >
                {window.innerWidth >= 600 ? (
                  <h1 className="form-title">
                    {this.state.add_new_service ? "Add Service" : "Services"}
                  </h1>
                ) : (
                  ""
                )}
                <form
                  id="services-inner-container"
                  action=""
                  onSubmit={this.all_services}
                  className="service-form-layout"
                >
                  {/* Left Column */}
                  <div className="service-form-left">
                    <Input
                      label="Service"
                      placeholder="Enter service name"
                      required
                      name="name"
                    />
                    <div className="input-grid">
                      <Select
                        placeholder="Select"
                        name="duration"
                        label="Duration"
                        required
                      >
                        {durations.map((duration) => (
                          <option value={duration.value} key={duration.value}>
                            {duration.text}
                          </option>
                        ))}
                      </Select>
                       <span className="sep" style={{ margin: "5px" }}>
                        {" "}
                      </span>
                      <Input
                        label={this.state.isGroupSession ? "Price per person (₦)" : "Price (₦)"}
                        type="number"
                        required
                        min="1"
                        placeholder="Enter Price"
                        name="price"
                      />
                    </div>
                    <div>
                      <Textarea
                        label="Description (optional)"
                        placeholder="Enter description here"
                        name="description"
                      />
                    </div>
                    <div className="input-rapper service-media-section">
                      <p className="label">IMAGES & VIDEOS (OPTIONAL)</p>
                      <input
                        type="file"
                        accept="image/*,video/*"
                        multiple
                        onChange={this.handleFileChange}
                        className="media-file-input"
                      />
                      <div className="input_highlight">
                        <small>
                          You can select up to 5 images or videos (max 25 MB each).
                        </small>
                      </div>
                      <MediaDnDList
                        items={this.state.allMedia}
                        onItemsChange={(newList) =>
                          this.setState({ allMedia: newList })
                        }
                        onRemove={this.handleRemove}
                      />
                    </div>

                    <div className="flex center space-btw web_only service-form-actions">
                        <button
                          className="left-btn"
                          type="button"
                          onClick={this.service_form}
                        >
                          Back to services
                        </button>
                        <button
                          type="submit"
                          className={`default ${this.state.submitingService ? "loading" : ""
                            }`}
                        >
                          Save
                        </button>
                      </div>
                  </div>

                  {/* Right Column */}
                  <div className="service-form-right">
                    {/* Booking Options Section */}
                    <div className="booking-options-section">
                      <p className="section-label">BOOKING OPTIONS</p>

                      <div className="booking-option-item">
                        <div className="booking-option-text">
                          <p className="booking-option-title">Online Service</p>
                          <p className="booking-option-desc">
                            The client will receive a meeting link if your calendar is linked.
                          </p>
                        </div>
                        <Toggle
                          data_open={this.state.isVirtual}
                          OnChange={(value) => this.setState({ isVirtual: value })}
                        />
                      </div>

                      <div className="booking-option-item">
                        <div className="booking-option-text">
                          <p className="booking-option-title">Group Session</p>
                          <p className="booking-option-desc">
                            Allow multiple clients per time slot. Useful for events or classes.
                          </p>
                        </div>
                        <Toggle
                          data_open={this.state.isGroupSession}
                          OnChange={(value) => this.setState({ isGroupSession: value })}
                        />
                      </div>

                      {this.state.isGroupSession && (
                        <div className="max-participants-input">
                          <Select
                            label="Max Participants"
                            name="max_participants"
                            value={this.state.maxParticipants}
                            onChange={(e) =>
                              this.setState({ maxParticipants: parseInt(e.target.value, 10) })
                            }
                          >
                            {[...Array(99)].map((_, i) => (
                              <option
                                key={i + 2}
                                value={i + 2}
                                selected={this.state.maxParticipants === i + 2}
                              >
                                {i + 2}
                              </option>
                            ))}
                          </Select>
                        </div>
                      )}
                    </div>

                    {/* Category Section */}
                    <div className="category-section">
                      <p className="section-label">CATEGORY (OPTIONAL)</p>
                      <NavLink
                        className="co-pink add-category-link"
                        to="/categories/settings"
                      >
                        <img src={add} alt="" />
                        Add category
                      </NavLink>
                      <div className="manage-cate-page">
                        {this.state.categories.map((category) => (
                          <CheckBox
                            key={category.id}
                            label={category.name}
                            value={category.id}
                            name="category[]"
                            onChange={this.handleCheckboxChangeCat}
                            checked={this.state.selectedCategories?.includes(
                              category.id
                            )}
                          />
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="flex center space-btw mobile_only">
                    <button
                      type="submit"
                      style={{ width: "90%", margin: "0 auto" }}
                      className={`default ${this.state.submitingService ? "loading" : ""
                        }`}
                    >
                      Add Service
                    </button>
                  </div>
                  <div></div>
                </form>
              </div>
              {/* end of add service modal */}

              {/* {this.state.editFormIsOpen ? */}
              <div
                id="settings-background"
                className="onboarding-page form-container card app-setting"
                style={{ display: this.state.editFormIsOpen ? "flex" : "none" }}
              >
                {window.innerWidth >= 600 ? (
                  <h1 className="form-title">
                    {this.state.editFormIsOpen ? "Edit Service" : "Services"}
                  </h1>
                ) : (
                  ""
                )}
                <form
                  id="services-inner-container"
                  action=""
                  onSubmit={this.editService}
                  ref={this.editServiceForm}
                  className="service-form-layout"
                >
                  {/* Left Column */}
                  <div className="service-form-left">
                    <Input
                      label="Service Name"
                      placeholder="Enter service name"
                      defaultValue={this.state.editFormDefaults.name}
                      required
                      name="name"
                    />
                    <div className="input-grid" ref={this.DurationInputRef}>
                      <Select
                        placeholder="00:00"
                        name="duration"
                        label="Duration (HH:MM)"
                        required
                      >
                        {durations.map((duration) => (
                          <option
                            value={duration.value}
                            selected={
                              this.state.editFormDefaults.duration ===
                              duration.value
                            }
                          >
                            {duration.text}
                          </option>
                        ))}
                      </Select>
                      <span className="sep" style={{ margin: "5px" }}>
                        {" "}
                      </span>

                      <Input
                        label={this.state.editIsGroupSession ? "Price per person (₦)" : "Price (₦)"}
                        type="number"
                        defaultValue={this.state.editFormDefaults.price}
                        placeholder="Enter Price"
                        name="price"
                        required min="1"
                      />
                    </div>
                    <div>
                      <Textarea
                        label="Description (optional)"
                        placeholder="Enter description here"
                        defaultValue={
                          this.state.editFormDefaults.description || ""
                        }
                        name="description"
                      />

                    </div>
                    <div className="input-rapper service-media-section">
                      <p className="label">IMAGES & VIDEOS (OPTIONAL)</p>
                      <input
                        type="file"
                        accept="image/*,video/*"
                        multiple
                        onChange={this.handleFileChange}
                        className="media-file-input"
                      />
                      <div className="input_highlight">
                        <small>
                          You can select up to 5 images or videos (max 25 MB each).
                        </small>
                      </div>
                      <MediaDnDList
                        items={this.state.allMedia}
                        onItemsChange={(newList) =>
                          this.setState({ allMedia: newList })
                        }
                        onRemove={this.handleRemove}
                      />
                    </div>

                    <div className="flex center space-btw web_only service-form-actions">
                      <button
                        className="left-btn"
                        type="button"
                        onClick={this.closeEditServiceForm}
                      >
                        Back to services
                      </button>
                      <button
                        type="submit"
                        className={`default ${
                          this.state.editingService ? "loading" : ""
                        }`}
                      >
                        Save
                      </button>
                    </div>
                  </div>

                  {/* Right Column */}
                  <div className="service-form-right">
                    {/* Booking Options Section */}
                    <div className="booking-options-section">
                      <p className="section-label">BOOKING OPTIONS</p>

                      <div className="booking-option-item">
                        <div className="booking-option-text">
                          <p className="booking-option-title">Online Service</p>
                          <p className="booking-option-desc">
                            The client will receive a meeting link if your calendar is linked.
                          </p>
                        </div>
                        <Toggle
                          data_open={this.state.editIsVirtual}
                          OnChange={(value) => this.setState({ editIsVirtual: value })}
                        />
                      </div>

                      <div className="booking-option-item">
                        <div className="booking-option-text">
                          <p className="booking-option-title">Group Session</p>
                          <p className="booking-option-desc">
                            Allow multiple clients per time slot. Useful for events or classes.
                          </p>
                        </div>
                        <Toggle
                          data_open={this.state.editIsGroupSession}
                          OnChange={(value) => this.setState({ editIsGroupSession: value })}
                        />
                      </div>

                      {this.state.editIsGroupSession && (
                        <div className="max-participants-input">
                          <Select
                            label="Max Participants"
                            name="max_participants"
                            value={this.state.editMaxParticipants}
                            onChange={(e) =>
                              this.setState({ editMaxParticipants: parseInt(e.target.value, 10) })
                            }
                          >
                            {[...Array(99)].map((_, i) => (
                              <option
                                key={i + 2}
                                value={i + 2}
                                selected={this.state.editMaxParticipants === i + 2}
                              >
                                {i + 2}
                              </option>
                            ))}
                          </Select>
                        </div>
                      )}
                    </div>

                    {/* Category Section */}
                    <div className="category-section">
                      <p className="section-label">CATEGORY (OPTIONAL)</p>
                      <NavLink
                        className="co-pink add-category-link"
                        to={"/categories/settings/" + this.state.editFormDefaults.id}
                      >
                        <img src={add} alt="" />
                        Add category
                      </NavLink>
                      <div className="manage-cate-page">
                        {this.state.categories.map((category) => (
                          <CheckBox
                            key={category.id}
                            label={category.name}
                            value={category.id}
                            name="category[]"
                            onChange={this.handleCheckboxChangeCat}
                            checked={this.state.selectedCategories?.includes(
                              category.id
                            )}
                          />
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="flex center space-btw mobile_only">
                    <button
                      type="submit"
                      style={{ width: "90%", margin: "0 auto" }}
                      className={`default ${this.state.submitingService ? "loading" : ""
                        }`}
                    >
                      Add Service
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {this.state.addCat ? (
            <div className="dsk-modal-rapper">
              <button
                className="absolute-bg"
                onClick={() => {
                  this.setState({ addCat: false });
                }}
              ></button>

              <div className="dsk-modal manage-cate-page container">
                {window.innerWidth >= 600 ? (
                  <button
                    onClick={() => {
                      this.setState({ addCat: false });
                    }}
                    className="close-btn wrapper dsk"
                    style={{ marginTop: "20px" }}
                  >
                    <img src={close} alt="" srcSet="" />
                  </button>
                ) : (
                  ""
                )}

                <div className="wrapper ">
                  <div className="section-header flex space-btw">
                    <p className="section-title flex center">
                      {" "}
                      <BackArrow
                        backFunction={this.closeAddServiceForm}
                        className="mbl"
                      />
                      Add new category
                    </p>
                  </div>
                  <div className="details card">
                    <form onSubmit={this.createCategory}>
                      <Input
                        label="Category name"
                        placeholder=""
                        defaultValue=""
                        name="name"
                        required
                      />
                      <div>
                        <h1 className="check_box_title">
                          Services in the category
                        </h1>
                        {this.state.services.map((service) => (
                          <CheckBox
                            key={service.id}
                            label={service.name}
                            value={service.id}
                            name="services[]"
                            onChange={this.handleCheckboxChange}
                          />
                        ))}
                      </div>
                      <div className="footer flex space-btw">
                        <br />
                        <button
                          className={`default ${this.state.is_loading ? "loading" : ""
                            }`}
                        >
                          Add Category
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </>
      );
    }
  }
);
